<template>
  <div id="_tlqn_member_home" style="height: 85%" class="column no-wrap">
    <user-info-card v-if="userDetail" :userDetail="userDetail" class="col-3" />
    <!-- tab -->
    <div class="col-9">
      <q-tabs
        v-model="tab"
        class="full-width text-grey q-mx-lg q-px-md q-mb-md"
        dense
        narrow-indicator
        active-color="primary"
        indicator-color="gray"
        inline-label
        style="height: 36px"
        :breakpoint="0"
        align="left"
        no-caps
      >
        <q-tab name="sampleDetail" class="rounded-borders" dense>
          <q-icon name="fas fa-city" size="0.8rem" class="q-mr-sm" />
          <span> 样本详情 </span>
        </q-tab>
        <q-tab name="sampleMapDetail" class="rounded-borders" dense>
          <q-icon name="fas fa-map" size="0.8rem" class="q-mr-sm" />
          <span> 地图分布 </span>
        </q-tab>
      </q-tabs>
      <!-- filter -->
      <q-scroll-area style="height: 36px" horizontal>
        <q-btn-toggle
          v-model="filterIndex"
          toggle-color="primary"
          class="q-mx-lg q-px-sm"
          flat
          dense
          text-color="grey-6"
          size="md"
          style="min-width: 1000px"
          :options="labelOptions"
          @input="filterSample"
        >
        </q-btn-toggle>
      </q-scroll-area>
      <!-- tab penel -->
      <q-tab-panels
        v-if="userDetail"
        v-model="tab"
        animated
        class="full-width full-height q-ma-none q-pa-none col-grow"
      >
        <!-- 样本列表 -->
        <q-tab-panel name="sampleDetail" class="column">
          <q-scroll-area class="col-grow column">
            <empty v-if="currentSamples.length === 0" class="q-mt-xl" />
            <q-list v-if="currentSamples">
              <q-item
                v-for="sample in currentSamples"
                :key="sample.id"
                clickable
                dense
                class="row items-center"
              >
                <!-- 样本 {{ i }} -->
                <member-sample-list v-if="sample" :sample="sample">
                </member-sample-list>
              </q-item>
            </q-list>
          </q-scroll-area>
        </q-tab-panel>
        <!-- 地图 -->
        <q-tab-panel
          name="sampleMapDetail"
          class="q-ma-none q-pa-none full-height no-scroll"
        >
          <empty class="q-pa-lg" v-if="sampleDetailWithPoints.length === 0" />
          <div class="items-center full-height justify-center" v-if="loading">
            <loading />
          </div>

          <div
            v-else-if="sampleDetailWithPoints && sampleDetailWithPoints.length"
            class="
              full-height
              relative-position
              q-ma-none q-mx-md
              rounded-borders
            "
          >
            <!-- 切换三个地图点 -->
            <div
              style="position: absolute; right: 10px; top: 10px; z-index: 999"
              class="bmap-custom-marker-controller"
            >
              <div
                class="bmap-custom-marker-control"
                :class="{
                  'bmap-custom-marker-control-active':
                    selectedType === type.key_prefix,
                }"
                v-for="type in pointType"
                :key="type.key_prefix"
                @click="selectedType = type.key_prefix"
              >
                {{ type.label }}
              </div>
            </div>
            <div
              class="fit rounded-borders"
              id="_tlqn_admin_sg_detail_distribution"
            ></div>
          </div>
        </q-tab-panel>
      </q-tab-panels>
    </div>
  </div>
</template>

<script>
import BMapMixin from "@/mixins/bmap.mixin";
import SampleLabelMixin from "../sample-label.mixin";
import UserDetailMixin from "../user-detail.mixin";
const customMarkPointLoader = () => import("@/libs/CustomMarkPoint");
const customMakePointControlLoader = () =>
  import("@/libs/CustomMarkPointStyleController");
export default {
  mixins: [UserDetailMixin, SampleLabelMixin, BMapMixin],
  components: {
    UserInfoCard: () => import("../components/UserInfoCard.vue"),
    MemberSampleList: () => import("../components/MemberSampleList"),
    Empty: () => import("@/components/Empty"),
    Loading: () => import("@/components/Loading"),
  },
  data() {
    return {
      tab: "sampleDetail",
      filterIndex: "-1",
      labelOptions: [
        {
          label: "全部",
          value: "-1",
        },
      ],
      currentSamples: [],
      loading: false,
      sampleDetailWithPoints: [],
      pointType: [
        { key_prefix: "dom", label: "注册地址" },
        { key_prefix: "addr", label: "经营地址" },
        { key_prefix: "entname", label: "地图检索地址" },
      ],
      selectedType: "dom",
    };
  },

  watch: {
    sampleLabel: {
      immediate: true,
      handler(current) {
        if (current) {
          this.labelOptions = [
            {
              label: "全部",
              value: "-1",
            },
          ];
          this.sampleLabel.map((label) => {
            const Options = {};
            Options.label = label.description;
            Options.value = label.value;
            // labelOptions.value = label.key;
            this.labelOptions.push(Options);
          });
        }

        this.labelOptions.sort((item1, item2) => {
          return item1.value - item2.value;
        });
      },
    },

    userDetail: {
      immediate: true,
      handler(current) {
        if (current) {
          this.currentSamples = this.userDetail.samples;
        }
      },
    },

    tab: {
      immediate: true,
      handler(current) {
        if (current) {
          if (this.tab === "sampleMapDetail") {
            this.renderMap();
          }
          if (this.tab === "sampleDetail") {
            // 重置一下
            this.selectedType = "dom";
          }
        }
      },
    },

    currentSamples: {
      immediate: true,
      handler() {
        this.sampleDetailWithPoints = this.currentSamples.filter(
          (sample) =>
            sample.detail[`${this.selectedType}_lon`] &&
            sample.detail[`${this.selectedType}_lat`]
        );
        if (this.tab === "sampleMapDetail") {
          this.selectedType = "dom";
          this.renderMap();
        }
      },
    },

    selectedType(newType) {
      if (newType) {
        this.sampleDetailWithPoints = this.currentSamples.filter(
          (sample) =>
            sample.detail[`${this.selectedType}_lon`] &&
            sample.detail[`${this.selectedType}_lat`]
        );
        this.renderMap();
      }
    },
  },

  methods: {
    filterSample() {
      if (this.filterIndex == "-1") {
        this.currentSamples = this.userDetail.samples.sort((a, b) => {
          return (
            new Date(b.timestamp.updatedAt) - new Date(a.timestamp.updatedAt)
          );
        });
      } else if (
        this.sampleLabel.some((item) => {
          if (item.value === this.filterIndex) {
            return item.sample_status;
          }
        })
      ) {
        const currentStatusLabel = this.sampleLabel.filter((item) => {
          return item.value === this.filterIndex;
        });
        this.currentSamples = this.userDetail.samples.filter((sample) => {
          return sample.sample_status == currentStatusLabel[0].sample_status;
        });
      } else {
        this.currentSamples = this.userDetail.samples.filter((sample) => {
          return sample.labels.some((sampleLabel) => {
            // console.log(sampleLabel)
            return sampleLabel.value == this.filterIndex;
          });
        });
      }
    },

    async renderMap() {
      const lng_key = `${this.selectedType}_lon`;
      const lat_key = `${this.selectedType}_lat`;
      const { sampleDetailWithPoints } = this;
      if (!sampleDetailWithPoints || !sampleDetailWithPoints.length) {
        // 地图消失了
        this.$q.notify({ type: "danger", message: "GIS 数据缺失" });
        return;
      }
      this.loading = true;
      const BMap = await this.loadBmap();
      const CustomMarkPoint = (await customMarkPointLoader()).default;
      const CustomMarkPointStyleController = (
        await customMakePointControlLoader()
      ).default;
      this.loading = false;
      this.$nextTick(() => {
        const map = new BMap.Map("_tlqn_admin_sg_detail_distribution");
        map.enableScrollWheelZoom(true);
        // 添加控件
        // 切换筛选内容的控件
        // map.addControl(new BMap.ScaleControl());
        const markPointStyleController = new CustomMarkPointStyleController();
        map.addControl(markPointStyleController);

        const { center, scale } = this.calculatePointsCenterAndScale(
          sampleDetailWithPoints.map((sample) => [
            sample.detail[lng_key],
            sample.detail[lat_key],
          ]),
          "#_tlqn_admin_sg_detail_distribution"
        );
        map.centerAndZoom(new BMap.Point(...center), scale);
        // 打点
        // 排序一下，不至于太乱
        sampleDetailWithPoints.sort((a, b) => {
          return (
            a.detail[lng_key] -
            b.detail[lng_key] +
            (b.detail[lat_key] - a.detail[lat_key])
          );
        });
        sampleDetailWithPoints.forEach((group) => {
          const bmapPoint = new BMap.Point(
            group.detail[lng_key],
            group.detail[lat_key]
          );
          // const MarkPoint = new BMap.Marker(bmapPoint);
          const MarkPoint = new CustomMarkPoint(
            group.id,
            bmapPoint,
            group.detail.name,
            group.detail.sample_id
          );

          // marker.setTitle(group.detail.name);
          // marker.setLabel(group.detail.name);
          map.addOverlay(MarkPoint);

          // 注册点击事件
          MarkPoint.addEventListener("click", (event, detail) => {
            event.stopPropagation();

            if (this.$route.query._gs && this.$route.query._gs === detail.id)
              return;
            this.$router.replace({
              query: {
                ...this.$route.query,
                _gs: detail._id,
                r: new Date().getTime(),
              },
            });
          });
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/quasar";
#_tlqn_member_home {
  .q-scroll {
    flex-grow: 1;
  }
}
</style>